import Box from '@mui/material/Box';

interface TabPanelProps {
  id?: string;
  children: React.ReactNode;
  index: number;
  value: number;
  paddingTop?: number;
}

function TabPanel(props: TabPanelProps) {
  const { id, children, value, index, paddingTop, ...other } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <div role='tabpanel' hidden={value !== index} id={id ?? `tabpanel-${index}`} {...other}>
      {value === index && <Box pt={paddingTop ?? 3}>{children}</Box>}
    </div>
  );
}

TabPanel.defaultProps = {
  id: undefined,
  paddingTop: undefined,
};

export default TabPanel;
